exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Variables\n */\n\n/**\n * Functions\n */\n.register-form[data-v-30ccda94] {\n\twidth: 100%;\n}\n", ""]);

// exports
